import ISmartScheduleShiftEntity, { WeekDays } from "./ISmartScheduleShiftEntity";
import BaseShiftEntity from "sh-models/shift/BaseShiftEntity";
import { ShiftType, ShiftTypes, ShiftStates, ModelUtils } from "sh-models";
import ThemeUtils from "../../sh-application/utility/ThemeUtils";
import { SHIFT_BLOCK_ID_PREFIX } from "../../StaffHubConstants";

/**
 * Class representing a Smart Schedule Shift Entity
 */
export default class SmartScheduleShiftEntity extends BaseShiftEntity implements ISmartScheduleShiftEntity {
    openSlots: number;
    repeatOn: WeekDays[];

    constructor(params: ISmartScheduleShiftEntity = {} as ISmartScheduleShiftEntity) {
        const {
            id,
            eTag,
            tenantId,
            teamId,
            memberId,
            shiftType,
            startTime,
            endTime,
            state,
            title,
            notes,
            theme,
            tagIds,
            subshifts,
            breaks,
            shiftRequestId,
            timeOffReasonId,
            isPublished,
            lastModifiedBy,
            isPredraft,
            openSlots,
            repeatOn
        } = params;

        let modelId = id || SmartScheduleShiftEntity.generateNewSmartScheduleShiftBlockId();
        super(
            modelId,
            eTag,
            tenantId,
            teamId,
            memberId,
            shiftType,
            startTime,
            endTime,
            state,
            title,
            notes,
            theme || ThemeUtils.shiftDefaultTheme,
            tagIds,
            subshifts,
            breaks,
            shiftRequestId,
            timeOffReasonId,
            isPublished,
            lastModifiedBy,
            isPredraft
        );
        this.openSlots = openSlots;
        this.repeatOn = repeatOn;
    }

    /**
     * Clone a SmartScheduleShiftEntity object
     * @param shift - shift to be cloned
     */
    static clone(shift: ISmartScheduleShiftEntity): ISmartScheduleShiftEntity | null {
        if (!shift) {
            return null;
        }
        return new SmartScheduleShiftEntity({
            ...shift,
            openSlots: shift.openSlots,
            repeatOn: shift.repeatOn ? [...shift.repeatOn] : []
        });
    }

    public static generateNewSmartScheduleShiftBlockId(): string {
        return ModelUtils.generateUUIDWithPrefix(SHIFT_BLOCK_ID_PREFIX);
    }

   static createEmptyObject(tenantId: string, teamId: string, memberId: string, shiftType: ShiftType = ShiftTypes.SmartSchedule, theme: string = ThemeUtils.shiftDefaultTheme): SmartScheduleShiftEntity {
        return new SmartScheduleShiftEntity({
            id: null,
            eTag: null,
            tenantId,
            teamId,
            memberId,
            shiftType: shiftType,
            state: ShiftStates.Active,
            startTime: null,
            endTime: null,
            title: null,
            theme,
            tagIds: [],
            subshifts: [],
            breaks: [],
            isPublished: false,
            lastModifiedBy: null,
            isPredraft: false,
            openSlots: 1,
            repeatOn: []
        });
    }
}
